module.exports = __webpack_public_path__ + "img/simona-carbonaro.0d229a81.png";